/**
 * @readonly
 * @enum {string}
 */
export const BrakePerformance = Object.freeze({
    BRAKE_EVENTS: 'brakeEvents',
    PERFORMANCE: 'performance',
    TIMESTAMP: 'timestamp',
    STATUS: 'status'
})
